import { FC, useContext, useMemo, useState } from 'react';

import { useRouter } from 'next/router';

import { FloatButton, Spin } from 'antd';

import { UserContext } from '@/context/user.context';
import useMobile from '@/hooks/use-mobile';
import { useVideoHelper } from '@/hooks/use-video-helper';

import { QuestionIcon } from './icon';
import { urlBlackList } from './VideoHelper.config';
import { VideoHelperModal } from './VideoHelperModal';

import styles from './VideoHelper.module.scss';

export const VideoHelper: FC = () => {
	const [isOpenModal, setIsOpenModal] = useState(false);
	const isMobile = useMobile();
	const { user } = useContext(UserContext);
	const router = useRouter();
	const { isLoading, videoData } = useVideoHelper({ setIsOpenModal });

	const tutorialKey = `${router.pathname}-${user?.id}`;

	const isPathInBlackList = useMemo(
		() => urlBlackList.includes(router.pathname),
		[router.pathname],
	);

	if (!user) {
		return null;
	}

	if (isLoading) {
		return <Spin />;
	}

	if (!isOpenModal && videoData && !isPathInBlackList) {
		return (
			<FloatButton
				data-testid="video-helper"
				type="primary"
				icon={<QuestionIcon />}
				tooltip="Инструкция"
				style={{
					left: isMobile ? 12 : 48,
					bottom: 12,
					display: 'block',
				}}
				onClick={() => setIsOpenModal(true)}
				className={styles.floatButtonBody}
				rootClassName={styles.floatButton}
			/>
		);
	}

	return (
		<VideoHelperModal
			open={isOpenModal}
			videoData={videoData}
			onCancel={() => {
				localStorage.setItem(tutorialKey, videoData?.updated);
				setIsOpenModal(false);
			}}
		/>
	);
};
